import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeResourceCalloutFields {
  title?: EntryFieldTypes.Symbol
  body?: EntryFieldTypes.RichText
}

export type TypeResourceCalloutSkeleton = EntrySkeletonType<TypeResourceCalloutFields, 'resourceCallout'>
export type TypeResourceCallout<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeResourceCalloutSkeleton,
  Modifiers,
  Locales
>

export function isTypeResourceCallout<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeResourceCallout<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'resourceCallout'
}
